export enum GoEmissionDesignatorInformationType {
    Data = 'Data',
    Voice = 'Voice',
    DataAndVoice = 'DataAndVoice',
}

export const GoEmissionDesignatorInformationTypeToLabelMapping = {
    [GoEmissionDesignatorInformationType.Data]: 'Data',
    [GoEmissionDesignatorInformationType.Voice]: 'Voice',
    [GoEmissionDesignatorInformationType.DataAndVoice]:
        'Data&nbsp;&&nbsp;Voice', // Requirement: "Data & Voice" should not break onto multiple lines
};
